module.exports = __webpack_public_path__ + "img/drowsy_ios_802.png";